module.exports = __webpack_public_path__ + "img/full_blue.14e950ba.jpg";